// src/utils/helpers.js

export const slugify = (text) => {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')     // Remplace les espaces par -
    .replace(/[^\w-]+/g, '')  // Enlève les caractères non alphanumériques (sauf -)
    .replace(/--+/g, '-');    // Remplace les multiples - par un seul -
};

// Tu pourrais ajouter d'autres fonctions utilitaires ici à l'avenir
// export const formatDate = (dateString) => { ... };